export default defineNuxtPlugin(() => {
  const { $onError } = useNuxtApp()

  const onVisibilityChange = async () => {
    if (document.hidden) {
      return
    }

    try {
      const { restartActiveMarketStreams } = await import(
        '@/store/derivative/streamBroker'
      )

      restartActiveMarketStreams('page-visible')
    } catch (error) {
      $onError(error)
    }
  }

  document.addEventListener('visibilitychange', onVisibilityChange)
})
